import React, { useState } from 'react';
import './index.scss';

interface ISearchTextBoxProps {
  searchFromList?: Array<SearchTextBoxItem>;
  placeholder: string;
  onSelect: (selectedItem: SearchTextBoxItem) => void;
}

export interface SearchTextBoxItem {
  id: string;
  name: string;
}

const SearchTextBox: React.FC<ISearchTextBoxProps> = props => {
  const { searchFromList, placeholder, onSelect } = props;

  const [searchQuery, setSearchQuery] = useState('');
  const [filteredTextList, setFilteredTextList] = useState([] as Array<SearchTextBoxItem>);
  const [showList, setShowList] = useState(false);

  const handleSearchChange = event => {
    const query = event.target.value;
    setSearchQuery(query);

    if (query) {
      const _filteredTextList = searchFromList?.filter(_ => _.name.toLowerCase().includes(query.toLowerCase())) || [];
      setFilteredTextList(_filteredTextList);
    } else {
      setFilteredTextList(searchFromList ?? []);
    }
  };

  const handleItemSelect = (text: SearchTextBoxItem) => {
    setSearchQuery('');
    setShowList(false);
    onSelect(text);
  };

  const handleOnFocus = () => {
    setShowList(true);
  };

  const handleOnBlur = () => {
    setTimeout(() => {
      setShowList(false);
    }, 200);
  };

  return (
    <>
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder={placeholder}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
      />
      <div>
        {showList && (
          <ul className="search-text-box-results">
            {filteredTextList.map((text, index) => {
              return (
                <li className="search-text-box-results-item" onClick={() => handleItemSelect(text)} key={index}>
                  {text.name}
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </>
  );
};
export default SearchTextBox;
